import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiFileExcel } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const SpotPurchaseOrdersMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (!user.equinor || !user.roles_names.includes("Spot - View")) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="spot purchase orders"
        name="spotPurchaseOrders"
        onClick={() => handleClick("spotPurchaseOrders")}
        title={t("menu.spotPurchaseOrders.title")}
        url="/create_purchase_order_by_spots"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiFileExcel} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.spotPurchaseOrders.title")}
            slotProps={{
              primary: { sx: { fontSize: 14 } },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
